import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { LOGO } from "./actionTypes";

const INIT_STATE = {
  listaLogo: {
    totalRecords: 0,
    records: [],
  },
  listaAllLogo: [],
  listaLogoHistory: [],
  loadingLogo: true,
  loadingLogoHistory: true,
  filterLogo: null,
  logo: null,
  logoHistory: null,
  messageLogo: null,
  isLogoSave: null,
  pageSizeLogo: DEFAULT_PAGE_SIZE,
  errorLoadingLogo: null,
  errorLoadingLogoHistory: null,
};

const LogoReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGO.GET_LISTA_LOGO.REQUEST:
      return {
        ...state,
        filterLogo: action.payload,
        loadingLogo: true,
      };

    case LOGO.GET_LISTA_LOGO.SUCCESS:
      return {
        ...state,
        listaLogo: action.payload,
        loadingLogo: false,
      };

    case LOGO.GET_LISTA_LOGO.FAIL:
      return {
        ...state,
        messageLogo: action.payload,
        loadingLogo: false,
      };
    case LOGO.GET_LOGO.REQUEST:
      return {
        ...state,
        loadingLogo: true,
      };

    case LOGO.GET_LOGO.SUCCESS:
      return {
        ...state,
        logo: action.payload,
        loadingLogo: false,
      };

    case LOGO.GET_LOGO.FAIL:
      return {
        ...state,
        messageLogo: action.payload,
        loadingLogo: false,
        errorLoadingLogo: true,
      };
    case LOGO.SAVE_LOGO.REQUEST:
      return {
        ...state,
        loadingLogo: true,
      };

    case LOGO.SAVE_LOGO.SUCCESS:
      return {
        ...state,
        loadingLogo: false,
        isLogoSave: action.payload,
      };

    case LOGO.SAVE_LOGO.FAIL:
      return {
        ...state,
        loadingLogo: false,
        isLogoSave: false,
        messageLogo: action.payload,
      };

    case LOGO.LOAD_EMPTY_LOGO:
      return {
        ...state,
        loadingLogo: false,
        logo: null,
        errorLoadingLogo: null,
        errorLoadingLogoHistory: null
      };

    case LOGO.CLEAN_MESSAGE_LOGO:
      return {
        ...state,
        messageLogo: null,
        isLogoSave: null,
        loadingLogo: false,
      };

    case LOGO.GET_LOGO_HISTORY.REQUEST:
      return {
        ...state,
        loadingLogo: true,
      };

    case LOGO.GET_LOGO_HISTORY.SUCCESS:
      return {
        ...state,
        loadingLogo: false,
        logo: action.payload,
      };

    case LOGO.GET_LOGO_HISTORY.FAIL:
      return {
        ...state,
        loadingLogo: false,
        messageLogo: action.payload,
        errorLoadingLogoHistory: true,
      };

    case LOGO.GET_LOGO_HISTORY_LIST.REQUEST:
      return {
        ...state,
        loadingLogoHistory: true,
      };

    case LOGO.GET_LOGO_HISTORY_LIST.SUCCESS:
      return {
        ...state,
        loadingLogoHistory: false,
        listaLogoHistory: action.payload,
      };

    case LOGO.GET_LOGO_HISTORY_LIST.FAIL:
      return {
        ...state,
        loadingLogoHistory: false,
        errorLoadingLogoHistory: true,
      };

    case LOGO.GET_LOGO_ALL.REQUEST:
      return {
        ...state,
        loadingLogo: true,
      };

    case LOGO.GET_LOGO_ALL.SUCCESS:
      return {
        ...state,
        loadingLogo: false,
        listaAllLogo: action.payload,
      };

    case LOGO.GET_LOGO_ALL.FAIL:
      return {
        ...state,
        loadingLogo: false,
        messageLogo: action.payload
      };

    case LOGO.CHANGE_PAGE_SIZE_LOGO:
      return {
        ...state,
        pageSizeLogo: action.payload,
      };

    default:
      return state;
  }
};

export default LogoReducer;
